import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[#E890A7]/10 bg-[#0A090B] py-14">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-4">
          <span className="bg-white/95 rounded-full px-4 py-2">
            <img src="/assets/joselle-logo.png" alt="Joselle Alves Broker" className="h-7 w-auto" />
          </span>
          <div>
            <p className="font-display text-lg leading-none">Lagoon City Real Estate</p>
            <p className="text-[11px] text-slate-500 mt-1">Joselle Alves · Broker — iCloud Realty Ltd., Brokerage</p>
            <a
              data-testid="footer-website-link"
              href="https://www.lagooncityrealestate.ca"
              target="_blank"
              rel="noreferrer"
              className="text-[11px] text-[#E890A7]/70 hover:text-[#F2A7BA] transition-colors"
            >
              www.lagooncityrealestate.ca
            </a>
          </div>
        </div>

        <nav className="flex flex-wrap justify-center gap-6 text-sm text-slate-400">
          <Link data-testid="footer-link-properties" to="/#properties" className="hover:text-[#F2A7BA] transition-colors">Waterfront Homes for Sale</Link>
          <Link data-testid="footer-link-about" to="/#about" className="hover:text-[#F2A7BA] transition-colors">About</Link>
          <Link data-testid="footer-link-newsletter" to="/#newsletter" className="hover:text-[#F2A7BA] transition-colors">Newsletter</Link>
          <Link data-testid="footer-link-community" to="/living-in-lagoon-city" className="hover:text-[#F2A7BA] transition-colors">Community</Link>
          <Link data-testid="footer-link-contact" to="/#contact" className="hover:text-[#F2A7BA] transition-colors">Contact</Link>
          <Link data-testid="footer-owner-login" to="/admin" className="font-mono text-xs tracking-widest uppercase text-slate-600 hover:text-[#E890A7] transition-colors">
            Owner Login
          </Link>
        </nav>
      </div>
      <p className="text-center text-[11px] text-slate-700 mt-10">
        © 2026 Joselle Alves, Broker — Lagoon City Real Estate. All rights reserved.
      </p>
    </footer>
  );
}
